import { useMemo, useState, useEffect } from 'react'

import {
  MaterialReactTable,
  useMaterialReactTable,
  MRT_ToggleDensePaddingButton,
  MRT_ShowHideColumnsButton,
  MRT_ToggleFullScreenButton,
  MRT_ToggleFiltersButton,
  MRT_ToggleGlobalFilterButton
} from 'material-react-table'

import OpenInNewIcon from '@mui/icons-material/OpenInNew'

import moment from 'moment-timezone'
import _ from 'lodash'

import { Box } from '@mui/material'

const ScanReportDates = ({ dates,loading, viewReport }) => {


  const viewDetails = ts => {

  }

  const columns = useMemo(() => [
    {
      id: "ts",
      accessorFn: (originalRow) => moment(originalRow.ts, "YYYYMMDDHHmmss"),
      header: 'Date',
      Cell: ({ cell, row }) => <div className='link' onClick={() => { viewReport(row.id) }}><OpenInNewIcon className='mr-5 grey' />{cell.getValue().format("DD MMM YYYY HH:mm")}</div>,
      filterVariant: 'date-range',
      sortingFn: 'datetime',
      size: 180
    },
    {
      accessorKey: 'numPasses',
      header: 'Number of passes scanned',
      filterVariant: 'autocomplete',
      size: 100,    
    },
  ])

  const table = useMaterialReactTable({
    columns,
    data:dates,
    state: {
      isLoading: loading
    },
    initialState: { showColumnFilters: false },
    enablePagination: false,
    enableBottomToolbar: false,
    enableRowSelection: false,
    enableMultiRowSelection: false,
    enableRowActions: false,
    enableStickyHeader: true,
    enableStickyFooter: true,
    positionToolbarAlertBanner: "none",
    getRowId: (originalRow) => originalRow.ts,
    muiTablePaperProps: {
      sx: {
        top: 180,
        bottom: 5,
        left: 5,
        right: 5,
        position: "fixed"
      },
      elevation: 3,
    },
    muiTableContainerProps: {
      sx: {
        top: 220,
        bottom: 5,
        left: 5,
        right: 5,
        position: "fixed"
      }
    },
    renderToolbarInternalActions: ({ table }) => (
      <Box>
        <MRT_ToggleGlobalFilterButton table={table} />
        <MRT_ToggleFiltersButton table={table} />
        <MRT_ShowHideColumnsButton table={table} />
        <MRT_ToggleDensePaddingButton table={table} />
        <MRT_ToggleFullScreenButton table={table} />
      </Box>
    )
  })

  return (
    <>
      <MaterialReactTable table={table} />
    </>)
}

export default ScanReportDates